import React, { useEffect } from "react";
import {
  Route,
  Routes,
  Outlet,
  HashRouter as Router, // Alterado para HashRouter
} from "react-router-dom";

import "./css/style.min.css";
import "./css/print.css";
// import "./css/style.min.css.map";
// import "./css/style.scss";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import Nav from "./components/Nav";
import Pesq from "./components/Pesq";
import SectionDestined from "./components/SectionDestined";
import SectionCare from "./components/SectionCare";
import SectionProductAccess from "./components/SectionProductAccess";
import Service from "./components/Service";
import Security from "./components/Security";
import ContactUs from "./components/ContactUs";
import InformationGuide from "./components/InformationGuide";
import GuildDashboard from "./components/GuildDashboard";
import Network from "./components/Network";
import Wireless from "./components/Wireless";
import System from "./components/System";
import WarrantyTerm from "./components/WarrantyTerm";
import ResetStandardFactory from "./components/ResetStandardFactory";
import Devices from "./components/Devices";
// import WirelessAccessPoints from "./components/WirelessAccessPoints";
import Connection from "./components/Connection";

import handleFirstLoad from "./js/handleFirstLoad";
import DOMContentLoaded from "./js/script";
import searchBar from "./js/searchBar";

handleFirstLoad();

const LayoutWrapper = () => {
  useEffect(() => {
    DOMContentLoaded();
    searchBar();
  }, []);

  return (
    <>
      <Nav />
      <div className="position-absolute bottom-0 container-fluid p-2 p-md-2 pe-xss-0 p-sm-0 pe-md-1 pe-lg-4 d-flex align-items-center">
        <button
          type="button"
          className="d-flex justify-content-center align-items-center btn ms-auto"
          id="scroll-top-btn"
        >
          <i className="fa fa-arrow-up" aria-hidden="true"></i>
        </button>
      </div>
    </>
  );
};

const RouteWrapper = ({ isPrivate }) => {
  return (
    <>
      <LayoutWrapper />
      <Outlet />
    </>
  );
};

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route element={<RouteWrapper />}>
          <Route
            path="/"
            element={
              <>
                <div
                  className="container-fluid d-flex flex-column"
                  id="main-container"
                >
                  <Pesq />
                  <div className="d-flex flex-wrap p-3" id="content">
                    <>
                      {/* <SectionDestined /> */}
                      <SectionCare />
                      <SectionProductAccess />
                      <InformationGuide />
                      <GuildDashboard />
                      <Network />
                      <Wireless />
                      <System />
                      <Service />
                      <Security />
                      <Connection />
                      <ResetStandardFactory />
                      <WarrantyTerm />
                      <ContactUs />
                    </>
                  </div>
                </div>
              </>
            }
          />
        </Route>

        <Route
          path="/devices"
          element={
            <>
              <div
                className="container-fluid d-flex flex-column"
                id="main-container"
              >
                <Pesq menu={false} search={false} />
                <Devices />
              </div>
            </>
          }
        />

        {/* <Route
          path="/supported-channels"
          element={
            <>
              <div
                className="container-fluid d-flex flex-column"
                id="main-container"
              >
                <Pesq menu={true} search={true} />
                <WirelessAccessPoints />
              </div>
            </>
          }
        /> */}

      </Routes>
    </Router>
  );
};

export default AppRoutes;
